/**
 * @file
 * A cross-platform helper for loading scripts with a callback.
 */

export default function loadjs(url, callback, onerror) {
	const script = document.createElement("script");
	script.type = "text/javascript";

	// ie
	if (script.readyState) {
		script.onreadystatechange = () => {
			if (script.readyState === "loaded" || script.readyState === "complete") {
				script.onreadystatechange = null;
				callback();
			}
		};
	}

	// other browsers
	else {
		script.onload = callback;
		script.onerror = onerror;
	}

	script.src = url;
	document.getElementsByTagName("head")[0].appendChild(script);
}



// WEBPACK FOOTER //
// ./src/shared/util/loadjs.js